<ion-app [class.desktop]="config.isWebApp">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
